import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './Margin.module.scss.js';

var _excluded = ["children", "className", "preset"];
var Margin = function Margin(_ref) {
  var children = _ref.children,
    className = _ref.className,
    preset = _ref.preset,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cx(styles.margin, styles[preset + "MarginPreset"], className)
  }, props), children);
};
Margin.propTypes = {
  children: PropTypes.node,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /** Required preset to ensure some normalcy */
  preset: PropTypes.oneOf(['default', 'modal', 'spacious', 'narrow']).isRequired
};
Margin.defaultProps = {
  preset: 'default'
};

export { Margin as default };
//# sourceMappingURL=index.js.map
